import { render, staticRenderFns } from "./AppointmentStatusControl.vue?vue&type=template&id=97507114&scoped=true"
import script from "./AppointmentStatusControl.vue?vue&type=script&lang=js"
export * from "./AppointmentStatusControl.vue?vue&type=script&lang=js"
import "./AppointmentStatusControl.vue?vue&type=style&index=0&id=97507114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97507114",
  null
  
)

export default component.exports